
import { authHeader } from '../_helpers';
import { CONST } from '../_config';

export const userService = {
    staticsData,
    updatePassword,
    login,
    logout,
    addUser,
    uploadImage,
    getUserList,
    disableUser,
    updateUser,
    deleteUser,
    getAllUser,
    loginLandlord,
    landlordStaticsData,
    forgotPassword,
    forgotUpdatePassword,
    dashBoardDataLandLord,
    TradeHoursContractorsJobsLandLord,
    TotalHoursInternalStaffLandLord,
    TotalHoursContractorsLandLord,
    locationJobsLandLord,
    companyContractorJobsLandLord,
    companyInternalStaffJobsLandLord
};
function logout() {
    localStorage.removeItem('user');
}
function login(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/adminlogin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfo: user.data
            }
            if (user.data) {
                localStorage.setItem('user', JSON.stringify(user.data));
            }

            return userObj;
        });
}
function loginLandlord(data) {
    console.log("fffffffffffffffffffffffffffff");
    let header = new Headers({
        'Content-Type': 'application/json',
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            console.log('daaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
            let userObj = {
                userinfo: user.data
            }
            if (user.data) {
                localStorage.setItem('user', JSON.stringify(user.data));
            }
            console.log("I am in srevice", userObj);
            return userObj;
        });
}
function getUserList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                getUserList: data.data
            }
            console.log();

            return userObj;
        });
}


function dashBoardDataLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/dashBoardDataLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                dashboardData: data.data
            }
            return userObj;
        });
}
function TotalHoursContractorsLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/TotalHoursContractorsLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                TotalHoursContractorsLandLord: data.data
            }
            return userObj;
        });
}
function TotalHoursInternalStaffLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/TotalHoursInternalStaffLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                TotalHoursInternalStaffLandLord: data.data
            }
            return userObj;
        });
}
function TradeHoursContractorsJobsLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/TradeHoursContractorsJobsLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                TradeHoursContractorsJobsLandLord: data.data
            }
            return userObj;
        });
}

function locationJobsLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/locationJobsLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                locationJobsLandLord: data.data
            }
            return userObj;
        });
}

function companyContractorJobsLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/companyContractorJobsLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                companyContractorJobsLandLord: data.data
            }
            return userObj;
        });
}


function companyInternalStaffJobsLandLord() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }


    return fetch(CONST.BACKEND_URL2 + `/companyInternalStaffJobsLandLord`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                companyInternalStaffJobsLandLord: data.data
            }
            return userObj;
        });
}

function staticsData(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/staticsData`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                staticsData: data.data
            }
            console.log();

            return userObj;
        });
}
function landlordStaticsData(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/landlordStaticsData`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                landlordStaticsData: data.data
            }
            console.log();

            return userObj;
        });
}

function updatePassword(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updatePassword`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                updatePassword: data.data
            }
            console.log("I am in service", userObj);

            return userObj;
        });
}

function getAllUser() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }
    return fetch(CONST.BACKEND_URL + `/getAllUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                getAllUser: data.data
            }
            console.log();

            return userObj;
        });
}
function addUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createUser`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                addUser: data.data
            }
            console.log();

            return userObj;
        });
}
function updateUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                addUser: data.data
            }
            return userObj;
        });
}
function disableUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/changeState`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                addUser: data.data
            }
            console.log();

            return userObj;
        });
}
function deleteUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deleteUser`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                addUser: data.data
            }
            console.log();

            return userObj;
        });
}
function uploadImage(filedata) {

    let header = new Headers({
        "Authorization": authHeader().Authorization
    });
    var data = new FormData();
    data.append('image', filedata);

    const requestOptions = {
        method: "POST",
        headers: header,
        body: data
    }
    return fetch(CONST.BACKEND_URL + `/uploadFile`, requestOptions)
        .then(handleResponse)
        .then(res => {
            let userObj = {
                filesDetails: res.data
            }
            return userObj;
        });
}
function handleResponse(response) {


    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }
            console.log("datadatadata ", response);

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        //console.log("datadatadatadatadata   ", data.error);
        if (data.error) {
            console.log("datadatadatadatadata   ", data);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
function forgotPassword(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/forgotPassword`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                forgotPassword: user.data
            }
            return userObj;
        });
}
function forgotUpdatePassword(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/forgotUpdatePassword`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                forgotUpdatePassword: user
            }
            return userObj;
        });
}